import React, { useEffect, useState, useRef } from 'react';
import { PlayIcon } from 'lucide-react';
type DeferredVideoProps = {
  src: string;
  className?: string;
  priority?: boolean;
  poster?: string;
  interactive?: boolean;
};
export function DeferredVideo({
  src,
  className = '',
  priority = false,
  poster,
  interactive = false
}: DeferredVideoProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [shouldLoad, setShouldLoad] = useState(priority);
  const [isPlaying, setIsPlaying] = useState(!interactive);
  useEffect(() => {
    if (priority || shouldLoad || !containerRef.current) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShouldLoad(true);
        observer.disconnect();
      }
    }, {
      rootMargin: '320px 0px'
    });
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, [priority, shouldLoad]);
  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch(error => {
        console.error('Error playing video:', error);
        // Fallback: si falla por políticas del navegador, lo intentamos mutado
        if (videoRef.current) {
          videoRef.current.muted = true;
          videoRef.current.play().then(() => setIsPlaying(true));
        }
      });
    }
  };
  return <div ref={containerRef} className="absolute inset-0 bg-[#062f27]" data-id="element-1">
      {shouldLoad && <>
          <video ref={videoRef} autoPlay={!interactive} loop={!interactive} muted={!interactive} playsInline controls={interactive && isPlaying} poster={poster} preload={priority ? 'auto' : 'metadata'} className={className} onPause={() => interactive && setIsPlaying(false)} onPlay={() => interactive && setIsPlaying(true)} data-id="element-2">
            <source src={src} type={src.endsWith('.mov') ? 'video/quicktime' : 'video/mp4'} data-id="element-3" />
          </video>
          {interactive && !isPlaying && <button onClick={handlePlay} className="absolute inset-0 flex items-center justify-center bg-black/40 transition hover:bg-black/50 focus:outline-none" aria-label="Reproducir video" data-id="element-4">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-400 text-emerald-950 shadow-xl transition hover:scale-105" data-id="element-5">
                <PlayIcon className="ml-1 h-8 w-8 fill-current" data-id="element-6" />
              </div>
            </button>}
        </>}
    </div>;
}